export default class Position {
	minesAround: number;
	uncover = false;
	marked = false;
	markedWrong = false;
	exploded = false;
	constructor(readonly mine: boolean) {}
}
